import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { MarketDataProviderScope } from '@/providers';
import { AuthProvider } from '@/services/auth';
import { router } from '@/app/router';
import '@/design/global.css';

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');

createRoot(el).render(
  <StrictMode>
    <AuthProvider>
      <MarketDataProviderScope>
        <RouterProvider router={router} />
      </MarketDataProviderScope>
    </AuthProvider>
  </StrictMode>,
);
